import React, {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import SubTitle from "../../components/SubTitle";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import * as evaluationMasterApi from "../../api/permissionApi/evaluationMasterApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {useGetItemQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
  WPEvaluationMaster,
  initializeEvaluataionMaster,
} from "../../models/serverModels/permission/WPEvaluationMaster";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import {useQueryClient} from "react-query";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import EvaluationMasterForm from "./EvaluationMasterForm";

const UpdateEvaluationMaster = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const location = useLocation();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: dangerEvaluation, isLoading: isGetLoading} = useGetItemQuery<
    ResponseItem<WPEvaluationMaster>
  >({
    key: ["EvaluationMaster", id],
    api: () => evaluationMasterApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WPEvaluationMaster>,
    Params.Update<WPEvaluationMaster>
  >({
    api: evaluationMasterApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Permission/List/`);
        queryClient.invalidateQueries(["EvaluationMasterList"]);
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<WPEvaluationMaster>({
    defaultValues: dangerEvaluation?.item || initializeEvaluataionMaster(),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(dangerEvaluation?.item);
  }, [dangerEvaluation?.item, reset]);

  const onSubmit: SubmitHandler<WPEvaluationMaster> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeEvaluataionMaster(), ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle
        subTitle="작업위험성평가 수정
"
      />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <EvaluationMasterForm captionColor="#01579B" />
            <ConfirmButtonGroup
              link="/Permission/List"
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateEvaluationMaster;
